import React from 'react';

export const recordsDescription = (
  <div>
    <p>
      If you received care from a private medical facility, we can get that
      information for you. We’ll ask you about that later in this application.
    </p>
    <p>
      If you received care at a VA medical facility, we have access to those
      records and can get them for you.
    </p>
  </div>
);

export const datesDescription =
  'When were you in this hospital? Include the dates you were admitted and discharged for each stay.';
